// extracted by mini-css-extract-plugin
export default {"signupView":"style_signupView__65Sni"};